import { makeActions } from '@redux/crudCreator/actions';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { CreatePayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDeliveryTypesApi } from 'api/orders';

export const MODEL_NAME = 'delivery';

export const deliveryActions = makeActions(MODEL_NAME, 'id');

export const getAllDelivery = deliveryActions.getAll;
export const editDelivery = deliveryActions.edit;
export const createDelivery = deliveryActions.create;
export const getByIdDelivery = deliveryActions.getDataById;

export const getDeliveryTypes = createAsyncThunk(
  'delivery/getDeliveryTypes',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (payload: CreatePayloadType, thunkAPI) => {
    const { data } = payload;
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
        },
        getDeliveryTypesApi,
        data,
      );
      if (response) {
        return { isSuccess: true, data: response };
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
